import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMyProgressAPI,
  getStudentProgressAPI
} from "../../services/progress";

export let getMyProgress = createAsyncThunk(
  "progress/my",
  async (_, thunkApi) => {
    try {
      let response = await getMyProgressAPI();
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let getStudentProgress = createAsyncThunk(
  "progress/student",
  async (studentId, thunkApi) => {
    try {
      let response = await getStudentProgressAPI(studentId);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

let initialState = {
  loading: false,
  progressData: null,
  error: null,
  errorMsg: ""
};

let progressSlice = createSlice({
  name: "progress",
  initialState,
  reducers: {
    clearProgress: (state, action) => {
      state.loading = false;
      state.error = null;
      state.errorMsg = "";
    }
  },
  extraReducers: {
    [getMyProgress.pending]: (state, action) => {
      state.loading = true;
    },
    [getMyProgress.fulfilled]: (state, action) => {
      state.loading = false;
      state.progressData = action.payload.progress;
    },
    [getMyProgress.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to fetch progress";
    },
    [getStudentProgress.pending]: (state, action) => {
      state.loading = true;
    },
    [getStudentProgress.fulfilled]: (state, action) => {
      state.loading = false;
      state.progressData = action.payload.progress;
    },
    [getStudentProgress.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to fetch student progress";
    }
  }
});

let progressReducer = progressSlice.reducer;
export let { clearProgress } = progressSlice.actions;
export default progressReducer;

